import { DateTime } from "luxon";

export function groupSkuIntervalsByHour(quantityDataBy15Minutes) {
  const intervalGroups = quantityDataBy15Minutes.skus_intervals.reduce((groups, interval) => {
    // Parse the start time
    const dateTime = DateTime.fromMillis(interval.start_time);
    // Round down to the start of the hour
    const hourKey = dateTime.startOf("hour").toMillis();

    // Initialize the group if needed
    if (!groups.has(hourKey)) {
      groups.set(hourKey, []);
    }

    // Add the interval to its group
    groups.get(hourKey).push(interval);

    return groups;
  }, new Map());

  const intervalGroupedByHour = Array.from(intervalGroups, ([hourStartTime, skuIntervalsForHour]) => {
    return combine(hourStartTime, skuIntervalsForHour);
  });

  return {
    interval_in_seconds: 60 * 60,
    skus_intervals: intervalGroupedByHour,
  };
}

function combine(hourStartTime, skuIntervalsForHour) {
  const flattenSkuQuantities = [];
  skuIntervalsForHour.forEach((interval) => {
    if (interval.sku_quantities) {
      interval.sku_quantities.forEach((skuQTY) => flattenSkuQuantities.push(skuQTY));
    }
  });
  const quantitiesBySKU = flattenSkuQuantities.reduce((groupBySKU, interval) => {
    const { sku } = interval;
    if (!groupBySKU.has(sku)) {
      groupBySKU.set(sku, []);
    }
    groupBySKU.get(sku).push(interval);
    return groupBySKU;
  }, new Map());

  const combinedSkuQuantities = [];
  quantitiesBySKU.forEach((skuQuantities, sku) => {
    let totalQuantity = 0.0, totalWeight = 0.0, totalLength = 0.0, totalVolume = 0.0;
    let totalRejectedWeight = 0.0, totalRejectedLength = 0.0, totalRejectedVolume = 0.0;
    let totalUptime = 0;
    const flattenQuantityByUnit = [];
    skuQuantities.forEach((qtyForSKU) => {
      totalQuantity += qtyForSKU.quantity;
      totalWeight += (qtyForSKU.weight ?? 0.0);
      totalLength += (qtyForSKU.length ?? 0.0);
      totalVolume += (qtyForSKU.volume ?? 0.0);
      totalRejectedWeight += (qtyForSKU.weight ?? 0.0);
      totalRejectedLength += (qtyForSKU.length ?? 0.0);
      totalRejectedVolume += (qtyForSKU.volume ?? 0.0);
      totalUptime += qtyForSKU.uptime;

      qtyForSKU.quantity_by_unit.forEach((qtyForUnit) => flattenQuantityByUnit.push(qtyForUnit));
    });

    const quantityByUnit = flattenQuantityByUnit.reduce((groupByUnit, qtyForUnit) => {
      const { unit } = qtyForUnit;
      if (!groupByUnit.has(unit)) {
        groupByUnit.set(unit, []);
      }
      groupByUnit.get(unit).push(qtyForUnit);
      return groupByUnit;
    }, new Map());

    const combinedQuantityByUnit = [];
    quantityByUnit.forEach((quantitiesForUnit, unit) => {
      let quantity = 0.0, rejectedQuantity = 0.0, expectedQuantity = 0.0;
      quantitiesForUnit.forEach((qtyForUnit) => {
        quantity += qtyForUnit.qty;
        rejectedQuantity += qtyForUnit.rejected_qty;
        expectedQuantity += qtyForUnit.expected_qty;
      })

      combinedQuantityByUnit.push({
        unit: unit,
        qty: quantity,
        rejected_qty: rejectedQuantity,
        expected_qty: expectedQuantity,
      });
    });

    combinedSkuQuantities.push({
      sku: sku,
      quantity: totalQuantity,
      unit: skuQuantities[0].unit,
      quantity_by_unit: combinedQuantityByUnit,
      weight: totalWeight,
      length: totalLength,
      volume: totalVolume,
      rejected_weight: totalRejectedWeight,
      rejected_length: totalRejectedLength,
      rejected_volume: totalRejectedVolume,
      uptime: totalUptime,
    });
  });

  return {
    start_time: hourStartTime,
    end_time: hourStartTime + 60 * 60 * 1000,
    sku_quantities: combinedSkuQuantities,
  }
}
